<template>
  <div v-if="showFloor">
  <div class="spe-discount-code" v-if="!json.init" :style="commonStyle" :ddt-area="`component_${json.floorId}_复制优惠码组件`" ddt-expose="on">
    <div class="head" :style="headerStyle" v-if="jdata.header.type == 1">{{jdata.header.title}}</div>
    <img :src="jdata.header.titleImage" alt="" class="headImg" v-if="jdata.header.type == 2">
    <div v-for="(v,k) in discountCodes" :key="k"  class="discount-mr" :style="ddStyle" :class="{'no-left-right-padding': jdata.commonStyle.margin}">
      <!-- 一行一张 -->
      <div :class="{'one':v.length == 1,'two':v.length == 2,'more':v.length > 2, 'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}" :style="fontStyle">
        <div class="code" :class="{'bg1': jdata.columnsType == 2, 'bg2': jdata.columnsType == 3, 'bg3': jdata.columnsType == 4}"  v-for="(item, key) in v"  v-if="item"  :key="key" :style="codeStyle">
          <div class="l">
            <div class="price" v-if=" item.couponApplyMoneyType == 2 || item.couponApplyMoneyType == 3">{{item.faceValue || ''}}<span class="yuan">折</span></div>
            <div class="price" v-else><span class="yuan">¥</span>{{item.faceValue || ''}}</div>
            <div class="use" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}">{{item.couponMinDiscountDescription || ''}}</div>
          </div>
          <div class="c" :style="dashStyle"></div>
          <div class="r">
            <div class="title" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}">优惠码：{{item.promoCode}}</div>
            <div
              class="btn copy-tag"
              :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"
              :data-clipboard-text="item.promoCode"
              @click="copy($event,item.promoCode)"
              :style="btnStyle"
              :data-area="pt()"
              :data-pos="`component_${json.floorId}_复制优惠码组件.坑位${key + 1}_点击复制按钮`"
              :data-desc="item.promoCode"
              :dd_name="`${pt()}.component_${json.floorId}_复制优惠码组件.坑位${key + 1}_点击复制按.${item.promoCode}`"
              :ddt-click="`${pt()}.component_${json.floorId}_复制优惠码组件.坑位${key + 1}_点击复制按.${item.promoCode}`"
              :ddt-pit="`坑位${key + 1}_点击复制按`"
              :ddt-src="item.promoCode"
              ddt-expose="on"
            >点击复制</div>
          </div>
        </div>
      </div>
    </div>

    <img class="explainImg" :src="jdata.activityDescription.image" alt=""  v-if="jdata.activityDescription.type == 2" />
    <div class="explain" :style="explainStyle" v-if="jdata.activityDescription.type == 1">活动说明：{{jdata.activityDescription.content}}</div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import handleClipboard from "../assets/js/clipboard";

export default {
  name: "spe-discount-code",
  props: {
    json: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      discountCodes:[],
      showFloor: true
    }
  },
  inject: ['pt'],
  computed: {
    jdata() {
      return this.json.data || { commonStyle: {}, headerStyle: {} ,header:{}, explainStyle:[],fontStyle:{},btnStyle:{},dashStyle:{}};
    },
    commonStyle() {
      let sty = {};
      if (this.jdata.commonStyle.backgroundType == 1) {
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor = this.jdata.commonStyle.bgColor;
        }else {
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      } else if(this.jdata.commonStyle.backgroundType == 2){
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      }
      sty.padding = `0 ${this.jdata.commonStyle.margin || 0}px`
      return sty;
    },
    headerStyle() {
      let sty = {}
      if(this.jdata.header.type == 1){
        sty.backgroundColor = this.jdata.header.backgroundColor ,
        sty.color = this.jdata.header.titleColor
      }
      return sty
    },
    explainStyle() {
      let sty = {}
      if(this.jdata.activityDescription.type == 1){
        sty.backgroundColor = this.jdata.activityDescription.backgroundColor   || this.jdata.backgroundColor ,
        sty.color = this.jdata.activityDescription.contentColor
      }
      return sty
    },
    fontStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType == 1) {
        return {
          color:this.jdata.fontColor || this.jdata.fontDefaultColor
        }
      } 
    },
    btnStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType == 1) {
        return {
          backgroundColor:this.jdata.fontColor || this.jdata.fontDefaultColor,
          color:this.jdata.backgroundColor
        }
      }
    },
    dashStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType > 1) {
        return {
          display: 'none'
        }
      } else {
        return{
          borderRightColor: this.jdata.fontColor || this.jdata.fontDefaultColor
        }
      }
    },
    ddStyle(){
      if(!this.jdata.commonStyle.margin){
        let sty = {
          padding: `0 ${this.jdata.commonStyle.margin}px`
        };
        return sty;
      }
    },
    codeStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType == 1) {
        return{
          backgroundColor: this.jdata.backgroundColor
        }
      }
    }
  },
  watch:{
    json: {
      handler(newVal, oldVal) {
        if (newVal && newVal.compIden === 'spe-discount-code') {
          this.getPromotionCodes(JSON.parse(JSON.stringify(newVal)))
        } else {
          newVal && this.couponCodeInfoByCombiId(JSON.parse(JSON.stringify(newVal)))
        }
      },
      deep: true,
      immediate: true
    },
    discountCodes: {
      handler(newVal, oldVal) {
        this.discountCodes = newVal
      },
      deep: true,
      immediate: true
    },
  },
  created() {
  },
  mounted() {
  },
  methods:{
    /**
     * 获取优惠码
     */
    async getPromotionCodes(newVal) {
      let { errorCode, data } =  await this.$axios.get("/jmapi/cms/promotion/couponCodeInfo", { params:{floorId:newVal.floorId, pt: this.$route.query.pt} })
      if(!data) return;
      if(!this.json.data || !this.json.data.ids || !this.json.data.ids.length) return;
      let ids  = JSON.parse(JSON.stringify(this.json.data.ids)),arr = [];
      ids.forEach((v,k)=>{
        let line = v.split(','), sortArr = [];
        line.forEach(id=>{
          let findItem = data.filter(item => {return item.applyId == id})[0]
          findItem ? sortArr.push(findItem):''
        })
        arr[k] = sortArr.length > 0 ? sortArr : []
      })
      this.$set(this,'discountCodes',arr)
    },

    copy(event,text) {
      handleClipboard(event, text);
      this.$toast("复制成功")
    },
    /**
    * 获取优惠码组合
    */
    async couponCodeInfoByCombiId(newVal) {
      const { floorId, data } = newVal 
      const { pt } = this.$route.query
      if(!floorId || !data || !pt) {
        return
      }
      const { id } = data
      try {
        let { errorCode, data } =  await this.$axios.get("/jmapi/cms/promotion/couponCodeInfoByCombiId", { params:{ floorId, pt, id } })
        if(errorCode !== 0) {
          return
        }
        const { couponCodes, list } = data
        const arr = []
        couponCodes && couponCodes.forEach((v,k)=>{
          let line = v.split(','), sortArr = [];
          line && line.forEach(id=>{
            let findItem = list.filter(item => {return item.applyId == id})[0]
            findItem ? sortArr.push(findItem):''
          })
          arr[k] = sortArr.length > 0 ? sortArr : []
        })
        this.showFloor = arr.length > 0
        this.$set(this,'discountCodes',arr)
      } catch(e) {
        console.log(e)
      }
    }
  }



}
</script>

<style lang="less" scoped>
  .spe-discount-code{
    /*min-height: 600px;*/
    box-sizing: border-box;
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .head{
      font-size: .34rem;
      color: #333333;
      line-height: .34rem;
      height: .82rem;
      box-sizing: border-box;
      font-weight: bold;
      padding: .3rem .2rem;
      background-size: 100% 100%;
      background-position: 0 0;
      text-align: center;
    }
    .headImg{
      height: .82rem;
      width: 100%;
      display: block;
    }
    .explain{
      font-size: .24rem;
      color: #999999;
      letter-spacing: 0;
      line-height: .32rem;
      font-weight: 400;
      padding: 0.3rem .2rem;
    }
    .explainImg{
      width: 100%;
      display: block;
    }
    .one {
      padding: .05rem .2rem;
      color: #F23440;
      &.type1 {
        color: #F2346D;
      }
      &.type2 {
        color: #141414;
      }
      &.type3 {
        color: #FFFFFF;
      }   
      .code{
        width: 100%;
        height: 1.44rem;
        background-color: #FFEBEB;
        border-radius: .08rem;
        position: relative;
        overflow: hidden;
        padding: .18rem 0rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        &.bg1 {
          background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_code1_big-1681205757.png');
          background-size: 100% 100%;
        }
        &.bg2 {
          background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/bg_code2_big-1681205900.png');
          background-size: 100% 100%;
        }
        &.bg3 {
          background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/bg_code3_big-1681205960.png');
          background-size: 100% 100%;
        }
        .l{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 2.23rem;
          flex-shrink: 0;
          .price{
            font-size: .48rem;
            letter-spacing: 0;
            text-align: justify;
            line-height: .52rem;
            font-weight: 600;
            > span{
              font-size: .24rem;
              line-height: .32rem;
            }
          }
          .use{
            opacity: 0.7;
            font-size: .24rem;
            text-align: center;
            line-height: .24rem;
            font-weight: 400;
            margin-top: .12rem;
            &.type1 {
              color: #FD4F6A;
            }
            &.type2 {
              color: #444444;
            }
            &.type3 {
              color: rgba(255,255,255,0.90);
            }
          }
        }
        .c{
          height: 100%;
          border-right-color: #F23440;
          border-right-style: dashed;
          border-right-width: .02rem;
          opacity: 0.7;
        }
        .r{
          padding-left: .63rem;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .title{
            font-weight: bold;
            font-size: .28rem;
            text-align: justify;
            &.type1 {
              color: #FFFFFF;
              font-weight: 400;
            }
            &.type2 {
              color: #141414;
              font-weight: 400;
            }
            &.type3 {
              color: #A15D19;
              font-weight: 400;
            }
          }
          .btn{
            width: 2.24rem;
            height: .44rem;
            background: #F23440;
            border-radius: .22rem;
            font-size: .24rem;
            /*line-height: .24rem;*/
            color: #FFEBEB;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            &.type1 {
              color: #F2346D;
              background-image: linear-gradient(180deg, #FFF7E8 0%, #FFDDBC 100%);
            }
            &.type2 {
              color: #141414;
              background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/btn_code2_big-1681280116.png');
              background-size: 100% 100%;
            }
            &.type3 {
              color: #FFFFFF;
              background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/btn_code3_big-1681280199.png');
              background-size: 100% 100%;
            }
          }
        }
      }

    }

    .two{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: .05rem .2rem;
      color: #F23440;
      &.type1 {
        color: #F2346D;
      }
      &.type2 {
        color: #141414;
      }
      &.type3 {
        color: #FFFFFF;
      }      
      .code{
        width: calc(50% - 0.05rem);
        height: 1.44rem;
        background-color: #FFEBEB;
        border-radius: .08rem;
        position: relative;
        overflow: hidden;
        padding: .18rem 0rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        &.bg1 {
          background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_code1_middle-1681205788.png');
          background-size: 100% 100%;
        }
        &.bg2 {
          background-image: url('https://img62.ddimg.cn/upload_img/00834/h5/bg_code2_middle-1681205917.png');
          background-size: 100% 100%;
        }
        &.bg3 {
          background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/bg_code3_middle-1681205982.png');
          background-size: 100% 100%;
        }
        &:first-child {
          margin-right: 0.05rem;
        }
        &:last-child {
          margin-left: 0.05rem;
        }

        .l{
          width: 1.43rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          flex-shrink: 0;
          .price{
            font-size: .48rem;
            letter-spacing: 0;
            text-align: justify;
            line-height: .52rem;
            font-weight: 600;
            > span{
              font-size: .24rem;
              line-height: .32rem;
            }
          }
          .use{
            opacity: 0.7;
            font-size: .22rem;
            text-align: center;
            line-height: .24rem;
            font-weight: 400;
            margin-top: .12rem;
            &.type1 {
              color: #FD4F6A;
            }
            &.type2 {
              color: #444444;
            }
            &.type3 {
              color: rgba(255,255,255,0.90);
            }
          }
        }
        .c{
          height: 100%;
          border-right-color: #F23440;
          border-right-style: dashed;
          border-right-width: .02rem;
          opacity: 0.7;
        }
        .r{
          width: 2.03rem;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 0 0.15rem;
          box-sizing: border-box;
          .title{
            font-weight: bold;;
            font-size: .24rem;
            line-height: .28rem;
            &.type1 {
              color: #FFFFFF;
              font-weight: 400;
            }
            &.type2 {
              color: #141414;
              font-weight: 400;
            }
            &.type3 {
              color: #A15D19;
              font-weight: 400;
            }
          }
          .btn{
            width: 1.7rem;
            height: .40rem;
            background: #F23440;
            border-radius: .22rem;
            font-size: .24rem;
            /*line-height: .28rem;*/
            color: #FFEBEB;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            &.type1 {
              color: #F2346D;
              background-image: linear-gradient(180deg, #FFF7E8 0%, #FFDDBC 100%);
            }
            &.type2 {
              color: #141414;
              background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/btn_code2_middle-1681280143.png');
              background-size: 100% 100%;
            }
            &.type3 {
              color: #FFFFFF;
              background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/btn_code3_middle-1681280222.png');
              background-size: 100% 100%;
            }
          }
        }
      }

    }


    .more{
      width: max-content;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      overflow-x: auto;
      padding: .05rem .2rem;
      color: #F23440;
      &::-webkit-scrollbar{width:0px;height:0px;}
      &.type1 {
        color: #F2346D;
      }
      &.type2 {
        color: #141414;
      }
      &.type3 {
        color: #FFFFFF;
      }   
      .code{
        width: 3.28rem;
        height: 1.44rem;
        background-color: #FFEBEB;
        border-radius: .08rem;
        position: relative;
        overflow: hidden;
        padding: .18rem 0rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        margin-right: .1rem;
        &.bg1 {
          background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/bg_code1_small-1681205875.png');
          background-size: 100% 100%;
        }
        &.bg2 {
          background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_code2_small-1681205940.png');
          background-size: 100% 100%;
        }
        &.bg3 {
          background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_code3_small-1681206002.png');
          background-size: 100% 100%;
        }
        &:last-child{
          margin-right: 0;
        }
        &:last-child:after{
          content: "";
          width: .2rem;
          height: 100%;
          position: absolute;
          right: -.2rem;
          top: 0rem;
        }
        .l{
          width: 1.43rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          flex-shrink: 0;
          .price{
            font-size: .48rem;
            letter-spacing: 0;
            text-align: justify;
            line-height: .52rem;
            font-weight: 600;
            > span{
              font-size: .24rem;
              line-height: .32rem;
            }
          }
          .use{
            opacity: 0.7;
            font-size: .22rem;
            text-align: center;
            line-height: .24rem;
            font-weight: 400;
            margin-top: .12rem;
            &.type1 {
              color: #FD4F6A;
            }
            &.type2 {
              color: #444444;
            }
            &.type3 {
              color: rgba(255,255,255,0.90);
            }
          }
        }
        .c{
          height: 100%;
          /*border-width*/
          /*  border-style*/
          /*  border-color*/
          opacity: 0.7;
          border-right-color: #F23440;
          border-right-style: dashed;
          border-right-width: .02rem;
        }
        .r{
          width: 1.81rem;
          padding: 0 0.11rem;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          box-sizing: border-box;
          .title{
            font-weight: bold;;
            font-size: .24rem;
            line-height: .28rem;
            &.type1 {
              color: #FFFFFF;
              font-weight: 400;
            }
            &.type2 {
              color: #141414;
              font-weight: 400;
            }
            &.type3 {
              color: #A15D19;
              font-weight: 400;
            }
          }
          .btn{
            width: 1.6rem;
            height: .40rem;
            background: #F23440;
            border-radius: .22rem;
            font-size: .24rem;
            /*line-height: .24rem;*/
            color: #FFEBEB;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            &.type1 {
              color: #F2346D;
              background-image: linear-gradient(180deg, #FFF7E8 0%, #FFDDBC 100%);
            }
            &.type2 {
              color: #141414;
              background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/btn_code2_small-1681280171.png');
              background-size: 100% 100%;
            }
            &.type3 {
              color: #FFFFFF;
              background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/btn_code3_small-1681280245.png');
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .discount-mr{
      overflow: scroll;
      &::-webkit-scrollbar{width:0px;height:0px;}
      &.no-left-right-padding {
        .one,.two,.more {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
</style>
